import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import Dashboard from '@/components/dashboard/Dashboard'
import ContactPersonList from '@/components/contactPerson/ContactPersonList'
import ContactPersonDetails from '@/components/contactPerson/ContactPersonDetails'
import ContractList from '@/components/contracts/ContractList'
import AccountDetails from '@/components/account/AccountDetails'
import AddressList from '@/components/address/AddressList'
import AddressSearchForm from '@/components/address/AddressSearchForm'
import AddressConfirmForm from '@/components/address/AddressConfirmForm'
import AddressDetails from '@/components/address/AddressDetails'
import AdminContractPartnerDetails from '@/components/admin/AdminContractPartnerDetails'
import AdminContractPartnerList from '@/components/admin/AdminContractPartnerList'
import AdminContractPartnerTemplateDetails from '@/components/admin/AdminContractPartnerTemplateDetails'
import AdminUserDetail from '@/components/admin/AdminUserDetail'
import AdminUserList from '@/components/admin/AdminUserList'
import PolicyHolderContracts from '@/components/policyholder/PolicyHolderContracts'
import PolicyHolderDetails from '@/components/policyholder/PolicyHolderDetails'
import SignIn from '@/components/auth/SignIn'
import SignUp from '@/components/auth/SignUp'
import SignUpConfirm from '@/components/auth/SignUpConfirm'
import SignUpContactPerson from '@/components/auth/SignUpContactPerson'
import SignUpContactPersonRejected from '@/components/auth/SignUpContactPersonRejected'
import ResetPassword from '@/components/auth/ResetPassword'
import ResetPasswordConfirm from '@/components/auth/ResetPasswordConfirm'
import Imprint from '@/components/info/Imprint'
import Terms from '@/components/info/Terms'
import Policies from '@/components/info/Policies'
import Faq from '@/components/info/Faq'
import InfoText from '@/components/info/InfoText'

Vue.use(Router)

const routes = [
  {
    path: '/signin',
    component: SignIn
  }, {
    path: '/signup',
    component: SignUp
  }, {
    path: '/signup/confirm',
    component: SignUpConfirm
  }, {
    path: '/signupcontactperson',
    component: SignUpContactPerson
  }, {
    path: '/signupcontactpersonrejected',
    component: SignUpContactPersonRejected
  }, {
    path: '/resetpassword',
    component: ResetPassword
  }, {
    path: '/resetpassword/confirm',
    component: ResetPasswordConfirm
  }, {
    path: '/',
    redirect: '/dashboard'
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/contactpersons',
    name: 'ContactPersonList',
    component: ContactPersonList,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/contactpersons/:id',
    name: 'ContactPersonDetails',
    component: ContactPersonDetails,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/contracts/:id',
    name: 'EditContract',
    component: ContractList,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/contracts',
    name: 'ContractList',
    component: ContractList,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/addresses',
    component: AddressList,
    meta: {
      requiresAuth: true
    },
    children: [{
      path: '',
      component: AddressSearchForm
    }, {
      path: 'confirm',
      component: AddressConfirmForm
    }]
  }, {
    path: '/addresses/:id',
    name: 'AddressDetails',
    component: AddressDetails,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/account',
    name: 'Account',
    component: AccountDetails,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/policyHolders/:id',
    name: 'PolicyHolderDetails',
    component: PolicyHolderDetails,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/policyHolders/:id/:contractId',
    name: 'ViewPolicyHolderContracts',
    component: PolicyHolderContracts,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/faq',
    name: 'Faq',
    component: Faq,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/imprint',
    name: 'Imprint',
    component: Imprint
  },
  {
    path: '/info',
    name: 'Info',
    component: InfoText
  }, {
    path: '/terms',
    name: 'Terms',
    component: Terms
  }, {
    path: '/policies',
    name: 'Policies',
    component: Policies
  }, {
    path: '/admin/users',
    name: 'AdminUserList',
    component: AdminUserList,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/admin/users/:id',
    name: 'AdminUserDetail',
    component: AdminUserDetail,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/admin/contractpartners',
    name: 'AdminContractPartnerList',
    component: AdminContractPartnerList,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/admin/contractpartners/:id',
    name: 'AdminContractPartnerDetails',
    component: AdminContractPartnerDetails,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/admin/contractpartners/template/:id',
    name: 'AdminContractPartnerTemplateDetails',
    component: AdminContractPartnerTemplateDetails,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new Router({routes})
router.beforeEach((to, from, next) => {
  const currentUser = store.getters.currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth) {
    if (Object.keys(currentUser).length === 0) {
      next({
        path: '/signIn',
        query: {redirect: to.fullPath}
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js